namespace JupitersChoice {
    export class StartRequiredAudioCmd {

        @inject('AudioModel') _audioModel: AudioModel;

        execute(): void {
            this._audioModel.returnToBaseGame();
        }
    }
}